export const languageMapping_de = {
    "ab": "Abchasisch",
    "aa": "Afar",
    "af": "Afrikaans",
    "ak": "Akan",
    "sq": "Albanisch",
    "am": "Amharisch",
    "ar": "Arabisch",
    "an": "Aragonesisch",
    "hy": "Armenisch",
    "az": "Aserbaidschanisch",
    "as": "Assamesisch",
    "av": "Avarisch",
    "ae": "Avestisch",
    "ay": "Aymara",
    "bm": "Bambara",
    "ba": "Baschkirisch",
    "eu": "Baskisch",
    "bn": "Bengalisch",
    "bh": "Bihari",
    "my": "Birmanisch",
    "bi": "Bislama",
    "nb": "Bokmål",
    "bs": "Bosnisch",
    "br": "Bretonisch",
    "bg": "Bulgarisch",
    "ch": "Chamorro",
    "ny": "Chichewa",
    "zh": "Chinesisch",
    "cr": "Cree",
    "de": "Deutsch",
    "de-CH": "Deutsch (Schweiz)",
    "de-AT": "Deutsch (Österreich)",
    "dv": "Dhivehi",
    "dz": "Dzongkha",
    "da": "Dänisch",
    "en": "Englisch",
    "eo": "Esperanto",
    "et": "Estnisch",
    "ee": "Ewe",
    "fj": "Fidschi",
    "fi": "Finnisch",
    "fr": "Französisch",
    "ff": "Fulfulde",
    "fo": "Färöisch",
    "gl": "Galicisch",
    "ka": "Georgisch",
    "el": "Griechisch",
    "kl": "Grönländisch",
    "gn": "Guaraní",
    "gu": "Gujarati",
    "ht": "Haitianisch",
    "ha": "Hausa",
    "he": "Hebräisch",
    "hi": "Hindi",
    "ho": "Hiri Motu",
    "io": "Ido",
    "ig": "Igbo",
    "id": "Indonesisch",
    "ia": "Interlingua",
    "ie": "Interlingue",
    "iu": "Inuktitut",
    "ik": "Inupiaq",
    "ga": "Irisch",
    "xh": "isiXhosa",
    "zu": "isiZulu",
    "is": "Isländisch",
    "it": "Italienisch",
    "ja": "Japanisch",
    "jv": "Javanisch",
    "yi": "Jiddisch",
    "kn": "Kannada",
    "kr": "Kanuri",
    "kk": "Kasachisch",
    "ks": "Kashmiri",
    "ca": "Katalanisch",
    "km": "Khmer",
    "kg": "Kikongo",
    "ki": "Kikuyu",
    "lu": "Kiluba",
    "rw": "Kinyarwanda",
    "cu": "Kirchenslawisch",
    "ky": "Kirgisisch",
    "rn": "Kirundi",
    "kv": "Komi",
    "ko": "Koreanisch",
    "kw": "Kornisch",
    "co": "Korsisch",
    "hr": "Kroatisch",
    "ku": "Kurdisch",
    "lo": "Laotisch",
    "la": "Latein",
    "lv": "Lettisch",
    "li": "Limburgisch",
    "ln": "Lingála",
    "lt": "Litauisch",
    "lg": "Luganda",
    "lb": "Luxemburgisch",
    "mg": "Malagasy",
    "ms": "Malaiisch",
    "ml": "Malayalam",
    "mt": "Maltesisch",
    "gv": "Manx",
    "mi": "Maori",
    "mr": "Marathi",
    "mh": "Marshallesisch",
    "mk": "Mazedonisch",
    "mn": "Mongolisch",
    "na": "Nauruisch",
    "nv": "Navajo",
    "ng": "Ndonga",
    "ne": "Nepali",
    "nl": "Niederländisch",
    "nd": "Nord-Ndebele",
    "se": "Nordsamisch",
    "no": "Norwegisch",
    "nn": "Nynorsk",
    "oj": "Ojibwe",
    "oc": "Okzitanisch",
    "or": "Oriya",
    "om": "Oromo",
    "kj": "oshiKwanyama",
    "os": "Ossetisch",
    "hz": "Otjiherero",
    "pi": "Pali",
    "pa": "Panjabi",
    "ps": "Paschtunisch",
    "fa": "Persisch",
    "pl": "Polnisch",
    "pt": "Portugiesisch",
    "qu": "Quechua",
    "rm": "Romanisch",
    "ro": "Rumänisch",
    "ru": "Russisch",
    "sm": "Samoanisch",
    "sg": "Sango",
    "sa": "Sanskrit",
    "sc": "Sardisch",
    "gd": "Schottisch-gälisch",
    "sv": "Schwedisch",
    "sr": "Serbisch",
    "st": "Sesotho",
    "tn": "Setswana",
    "sn": "Shona",
    "sd": "Sindhi",
    "si": "Singhalesisch",
    "ss": "Siswati",
    "sk": "Slowakisch",
    "sl": "Slowenisch",
    "so": "Somali",
    "es": "Spanisch",
    "su": "Sundanesisch",
    "sw": "Swahili",
    "nr": "Süd-Ndebele",
    "tg": "Tadschikisch",
    "tl": "Tagalog",
    "ty": "Tahitianisch",
    "ta": "Tamil",
    "tt": "Tatarisch",
    "te": "Telugu",
    "th": "Thai",
    "bo": "Tibetisch",
    "ti": "Tigrinya",
    "to": "Tongaisch",
    "cs": "Tschechisch",
    "ce": "Tschetschenisch",
    "cv": "Tschuwaschisch",
    "ve": "Tshivenda",
    "tk": "Turkmenisch",
    "tw": "Twi",
    "tr": "Türkisch",
    "ug": "Uigurisch",
    "uk": "Ukrainisch",
    "hu": "Ungarisch",
    "ur": "Urdu",
    "uz": "Usbekisch",
    "vi": "Vietnamesisch",
    "vo": "Volapük",
    "cy": "Walisisch",
    "wa": "Wallonisch",
    "be": "Weißrussisch",
    "fy": "Westfriesisch",
    "wo": "Wolof",
    "ts": "Xitsonga",
    "ii": "Yi",
    "yo": "Yoruba",
    "za": "Zhuang"
};

export const languageMapping_en = {
    "ab": "Abkhazian",
    "aa": "Afar",
    "af": "Afrikaans",
    "ak": "Akan",
    "sq": "Albanian",
    "am": "Amharic",
    "ar": "Arabic",
    "an": "Aragonese",
    "hy": "Armenian",
    "as": "Assamese",
    "av": "Avaric",
    "ae": "Avestan",
    "ay": "Aymara",
    "az": "Azerbaijani",
    "bm": "Bambara",
    "ba": "Bashkir",
    "eu": "Basque",
    "be": "Belarusian",
    "bn": "Bengali",
    "bh": "Bihari",
    "bi": "Bislama",
    "bs": "Bosnian",
    "br": "Breton",
    "bg": "Bulgarian",
    "my": "Burmese",
    "ca": "Catalan",
    "ch": "Chamorro",
    "ce": "Chechen",
    "ny": "Chichewa",
    "zh": "Chinese",
    "cu": "Church Slavic",
    "cv": "Chuvash",
    "kw": "Cornish",
    "co": "Corsican",
    "cr": "Cree",
    "hr": "Croatian",
    "cs": "Czech",
    "da": "Danish",
    "dv": "Divehi",
    "nl": "Dutch",
    "dz": "Dzongkha",
    "en": "English",
    "eo": "Esperanto",
    "et": "Estonian",
    "ee": "Ewe",
    "fo": "Faroese",
    "fj": "Fijian",
    "fi": "Finnish",
    "fr": "French",
    "ff": "Fulah",
    "gl": "Galician",
    "lg": "Ganda",
    "ka": "Georgian",
    "de": "German",
    "de-AT": "German (Austria)",
    "de-CH": "German (Switzerland)",
    "el": "Greek",
    "gn": "Guaraní",
    "gu": "Gujarati",
    "ht": "Haitian",
    "ha": "Hausa",
    "he": "Hebrew",
    "hz": "Herero",
    "hi": "Hindi",
    "ho": "Hiri Motu",
    "hu": "Hungarian",
    "is": "Icelandic",
    "io": "Ido",
    "ig": "Igbo",
    "id": "Indonesian",
    "ia": "Interlingua",
    "ie": "Interlingue",
    "iu": "Inuktitut",
    "ik": "Inupiaq",
    "ga": "Irish",
    "it": "Italian",
    "ja": "Japanese",
    "jv": "Javanese",
    "kl": "Kalaallisut",
    "kn": "Kannada",
    "kr": "Kanuri",
    "ks": "Kashmiri",
    "kk": "Kazakh",
    "km": "Khmer",
    "ki": "Kikuyu",
    "rw": "Kinyarwanda",
    "ky": "Kirghiz",
    "kv": "Komi",
    "kg": "Kongo",
    "ko": "Korean",
    "kj": "Kuanyama",
    "ku": "Kurdish",
    "lo": "Lao",
    "la": "Latin",
    "lv": "Latvian",
    "li": "Limburgan",
    "ln": "Lingala",
    "lt": "Lithuanian",
    "lu": "Luba-Katanga",
    "lb": "Luxembourgish",
    "mk": "Macedonian",
    "mg": "Malagasy",
    "ms": "Malay",
    "ml": "Malayalam",
    "mt": "Maltese",
    "gv": "Manx",
    "mi": "Maori",
    "mr": "Marathi",
    "mh": "Marshallese",
    "mn": "Mongolian",
    "na": "Nauru",
    "nv": "Navajo",
    "ng": "Ndonga",
    "ne": "Nepali",
    "nd": "North Ndebele",
    "se": "Northern Sami",
    "no": "Norwegian",
    "nb": "Norwegian Bokmål",
    "nn": "Norwegian Nynorsk",
    "oc": "Occitan",
    "oj": "Ojibwa",
    "or": "Oriya",
    "om": "Oromo",
    "os": "Ossetian",
    "pi": "Pali",
    "ps": "Pashto",
    "fa": "Persian",
    "pl": "Polish",
    "pt": "Portuguese",
    "pa": "Punjabi",
    "qu": "Quechua",
    "ro": "Romanian",
    "rm": "Romansh",
    "rn": "Rundi",
    "ru": "Russian",
    "sm": "Samoan",
    "sg": "Sango",
    "sa": "Sanskrit",
    "sc": "Sardinian",
    "gd": "Scottish Gaelic",
    "sr": "Serbian",
    "sn": "Shona",
    "ii": "Sichuan Yi",
    "sd": "Sindhi",
    "si": "Sinhala",
    "sk": "Slovak",
    "sl": "Slovenian",
    "so": "Somali",
    "nr": "South Ndebele",
    "st": "Southern Sotho",
    "es": "Spanish",
    "su": "Sundanese",
    "sw": "Swahili",
    "ss": "Swati",
    "sv": "Swedish",
    "tl": "Tagalog",
    "ty": "Tahitian",
    "tg": "Tajik",
    "ta": "Tamil",
    "tt": "Tatar",
    "te": "Telugu",
    "th": "Thai",
    "bo": "Tibetan",
    "ti": "Tigrinya",
    "to": "Tonga",
    "ts": "Tsonga",
    "tn": "Tswana",
    "tr": "Turkish",
    "tk": "Turkmen",
    "tw": "Twi",
    "ug": "Uighur",
    "uk": "Ukrainian",
    "ur": "Urdu",
    "uz": "Uzbek",
    "ve": "Venda",
    "vi": "Vietnamese",
    "vo": "Volapük",
    "wa": "Walloon",
    "cy": "Welsh",
    "fy": "Western Frisian",
    "wo": "Wolof",
    "xh": "Xhosa",
    "yi": "Yiddish",
    "yo": "Yoruba",
    "za": "Zhuang",
    "zu": "Zulu"
};